"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * A custom wrapper of a MUI Button component
 */


var Button = function Button(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? '' : _ref$variant,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '' : _ref$size,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? '' : _ref$href,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: onClick,
    variant: variant,
    size: size,
    color: color,
    disableElevation: true,
    href: href.length ? href : ''
  }, label);
};

Button.propTypes = {
  variant: _propTypes.string.isRequired,
  color: _propTypes.string.isRequired,
  size: _propTypes.string.isRequired,
  href: _propTypes.string,
  onClick: _propTypes.func,
  label: _propTypes.string.isRequired
};
var _default = Button;
exports.default = _default;